import api, { type RequestBody } from ".";
import type { PaginatedList } from "src/types/api";
import type { SubAccount } from "src/types/customer";

export const createSubAccount = ({ businessUuid, ...data }: { businessUuid?: string } & RequestBody) =>
	api.post(`/subaccounts`, data, { params: { businessUuid } });

export const editSubAccount = ({ uuid, ...data }: { uuid?: string } & RequestBody) => api.put(`/subaccounts/${uuid}`, data);

export const deleteSubAccount = ({ uuid }: { uuid: string | number }) => api.delete(`/subaccounts/${uuid}`);

export const getSubAccounts = (params?: Record<string, unknown>) => api.get<PaginatedList<SubAccount>>(`/subaccounts/business`, { params });
